import React from 'react';
import {VelocityComponent} from 'velocity-react';

const ResultBar = (props) => {
    return (
        <div className="p-grid__bar">
            <VelocityComponent animation={{ width: (props.percent) ? props.percent+'%' : 0 }} duration={500}>
                <div className="p-grid__bar-a" />
            </VelocityComponent>
        </div>
    );
};

export default ResultBar;